import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Audio } from 'react-loader-spinner';
import { toast } from "react-toastify";
import Select from 'react-select';

import {
    CreateScheduleHooks,
    ScheduleGetByIdHooks,
} from "../../Helper/ScheduleHelper";
import { LayoutListhooks } from "../../Helper/LayoutHelper";
import { CampaginListHooks } from "../../Helper/CampaginHelper";
import { ScreenListHooks } from "../../Helper/ScreenHelper";
import { GroupListhooks } from "../../Helper/GroupHelper";

// Imports remain the same

function CreateScheduleComponent(props) {
    const navigate = useNavigate();
    const [layouts, setLayouts] = useState([]);
    const [campaignList, setCampaignList] = useState([]);
    const [screenList, setsceenList] = useState([]);
    const [screengroupList, setsceengroupList] = useState([]);
    const [isEditing, setIsEditing] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [eventType, setEventType] = useState("Layout");
    const [displayType, setDisplayType] = useState("Single Display");

    const [formData, setFormData] = useState({
        scheduleId: props.id,
        layoutId: "",
        campaignId: "",
        startClockTime: "",              // Now stores "HH:mm" format
        endClockTime: "",
        recurrence: "",
        recurrenceInterval: 1,
        recurrenceDays: [],
        recurrenceEndDate: "",
        startTime: "",
        screenId: "",
        screenGroupId: "",
        priority: "",
        eventName: "",
        createdBy: localStorage.getItem("userId"),
    });

    async function fetchData() {
        setIsLoading(true);
        const layoutData = await LayoutListhooks("", "Name", false, 1, 1000);
        if (layoutData) setLayouts(layoutData.items);

        const campaignData = await CampaginListHooks("", "Name", false, 1, 1000);
        if (campaignData) setCampaignList(campaignData.items);

        const screenData = await ScreenListHooks("", "Name", false, 1, 1000);
        if (screenData) setsceenList(screenData.items);

        const screengroupData = await GroupListhooks("", "Name", false, 1, 1000, 2);
        if (screengroupData) setsceengroupList(screengroupData.items);

        if (props.id !== undefined) {
            const data = await ScheduleGetByIdHooks(props.id);
            if (data) {
                setFormData({
                    ...formData,
                    ...data,
                    layoutId: data.layoutId || 0,
                    campaignId: data.campaignId || 0,
                    screenId: data.screenId || 0,
                    screenGroupId: data.screenGroupId || 0,
                    recurrenceDays: data.recurrenceDays || [],
                    recurrenceInterval: data.recurrenceInterval || 1,
                    startTime: data.startTime ? data.startTime.substring(0, 10) : "",
                    recurrenceEndDate: data.recurrenceEndDate ? data.recurrenceEndDate.substring(0, 10) : "",
                    startClockTime: data.startClockTime?.substring(0, 5) || "",
                    endClockTime: data.endClockTime?.substring(0, 5) || "",
                });
                setEventType(data.campaignId && data.campaignId !== 0 ? "Campaign" : "Layout");
                setDisplayType(data.screenGroupId && data.screenGroupId !== 0 ? "Display Group" : "Single Display");
                setIsEditing(true);
            }
        }

        setIsLoading(false);
    }

    useEffect(() => {
        fetchData();
    }, []);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleEventTypeChange = (e) => {
        const value = e.target.value;
        setEventType(value);
        setFormData(prev => ({
            ...prev,
            layoutId: "",
            campaignId: ""
        }));
    };

    const handleDisplayTypeChange = (e) => {
        const value = e.target.value;
        setDisplayType(value);
        setFormData(prev => ({
            ...prev,
            screenId: "",
            screenGroupId: ""
        }));
    };

    const handleDropdownChange = (selectedOption) => {
        const value = selectedOption ? selectedOption.value : 0;
        setFormData(prev => ({
            ...prev,
            layoutId: eventType === "Layout" ? value : 0,
            campaignId: eventType === "Campaign" ? value : 0
        }));
    };

    const handleScreenDropdownChange = (selectedOption) => {
        const value = selectedOption ? selectedOption.value : 0;
        setFormData(prev => ({
            ...prev,
            screenId: displayType === "Single Display" ? value : 0,
            screenGroupId: displayType === "Display Group" ? value : 0
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);

        const updatedFormData = {
            ...formData,
            // Optional: Convert time to "HH:mm:ss" format if needed by backend

            recurrenceDays: Array.isArray(formData.recurrenceDays)
                ? formData.recurrenceDays.join(",")
                : formData.recurrenceDays || "",
            recurrenceEndDate: formData.recurrenceEndDate
                ? new Date(formData.recurrenceEndDate).toISOString()
                : null,
            startTime: formData.startTime
                ? new Date(formData.startTime).toISOString()
                : null,
            startClockTime: formData.startClockTime ? `${formData.startClockTime}:00` : null,
            endClockTime: formData.endClockTime ? `${formData.endClockTime}:00` : null
        };

        const res = await CreateScheduleHooks(updatedFormData);
        if (res) {
            toast.success(props.id ? "Schedule Updated" : "Schedule Created", {
                position: "top-right", autoClose: 3000
            });

            if (!props.id) {
                setFormData({
                    scheduleId: 0,
                    layoutId: "",
                    campaignId: "",
                    startClockTime: "",
                    endClockTime: "",
                    recurrence: "",
                    recurrenceInterval: 1,
                    recurrenceDays: [],
                    recurrenceEndDate: "",
                    priority: "",
                    eventName: "",
                    screenId: "",
                    screenGroupId: "",
                    createdBy: localStorage.getItem("userId"),
                });
            }

            setTimeout(() => navigate("/schedule/ScheduleList"), 3000);
        } else {
            toast.error("Failed to save schedule. Try again.");
        }

        setIsLoading(false);
    };

    const layoutOptions = layouts.map(layout => ({ value: layout.layoutId, label: layout.name }));
    const campaignOptions = campaignList.map(c => ({ value: c.campaignId, label: c.name }));
    const screenOptions = screenList.map(c => ({ value: c.screenId, label: c.screenName }));
    const screenGroupOptions = screengroupList.map(c => ({ value: c.groupId, label: c.groupName }));
    const weekdays = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"].map(day => ({ value: day, label: day }));

    return (
        <div>

            <div className="container-fluid content-top-gap">
                <div className="card card_border">
                    <div className="card-header">{props.id ? "Edit Schedule" : "Add Schedule"}</div>
                    {isLoading ? (
                        <div className="d-flex justify-content-center align-items-center vh-100">
                            <Audio height="100" width="100" color="grey" />
                        </div>
                    ) : (
                        <div className="card-body">
                            <form onSubmit={handleSubmit}>
                                <div className="form-row">
                                    <div className="form-group col-md-6">
                                        <label>Event Name</label>
                                        <input type="text" className="form-control" name="eventName" value={formData.eventName} onChange={handleChange} required />
                                    </div>
                                    <div className="form-group col-md-6">
                                        <label>Priority</label>
                                        <select className="form-control" name="priority" value={formData.priority} onChange={handleChange} required>
                                            <option value="">Select Priority</option>
                                            <option value="1">Low</option>
                                            <option value="2">Medium</option>
                                            <option value="3">High</option>
                                        </select>
                                    </div>
                                    <div className="form-group col-md-6">
                                        <label>Event Type</label>
                                        <select className="form-control" value={eventType} onChange={handleEventTypeChange}>
                                            <option value="Layout">Layout</option>
                                            <option value="Campaign">Campaign</option>
                                        </select>
                                    </div>
                                    <div className="form-group col-md-6">
                                        <label>{eventType}</label>
                                        <Select
                                            options={eventType === "Layout" ? layoutOptions : campaignOptions}
                                            value={(eventType === "Layout"
                                                ? layoutOptions.find(opt => opt.value === Number(formData.layoutId))
                                                : campaignOptions.find(opt => opt.value === Number(formData.campaignId))) || null}
                                            onChange={handleDropdownChange}
                                            isClearable
                                        />
                                    </div>
                                    <div className="form-group col-md-6">
                                        <label>Display Type</label>
                                        <select className="form-control" value={displayType} onChange={handleDisplayTypeChange}>
                                            <option value="Single Display">Single Display</option>
                                            <option value="Display Group">Display Group</option>
                                        </select>
                                    </div>
                                    <div className="form-group col-md-6">
                                        <label>{displayType}</label>
                                        <Select
                                            options={displayType === "Single Display" ? screenOptions : screenGroupOptions}
                                            value={(displayType === "Single Display"
                                                ? screenOptions.find(opt => opt.value === Number(formData.screenId))
                                                : screenGroupOptions.find(opt => opt.value === Number(formData.screenGroupId))) || null}
                                            onChange={handleScreenDropdownChange}
                                            isClearable
                                        />
                                    </div>

                                    {/* Updated time-only inputs */}
                                    <div className="form-group col-md-6">
                                        <label>Start Time</label>
                                        <input type="time" className="form-control" name="startClockTime" value={formData.startClockTime} onChange={handleChange} required />
                                    </div>
                                    <div className="form-group col-md-6">
                                        <label>End Time</label>
                                        <input type="time" className="form-control" name="endClockTime" value={formData.endClockTime} onChange={handleChange} required />
                                    </div>

                                    <div className="form-group col-md-6">
                                        <label>Recurrence</label>
                                        <select className="form-control" name="recurrence" value={formData.recurrence} onChange={handleChange} required>
                                            <option value="">Select Recurrence</option>
                                            <option value="None">None</option>
                                            <option value="Daily">Daily</option>
                                            <option value="Weekly">Weekly</option>
                                            <option value="Monthly">Monthly</option>
                                        </select>
                                    </div>

                                    {formData.recurrence !== "None" && formData.recurrence !== "" && (
                                        <>
                                            <div className="form-group col-md-6">
                                                <label>Repeat Every</label>
                                                <input type="number" className="form-control" name="recurrenceInterval" value={formData.recurrenceInterval} onChange={handleChange} min="1" />
                                            </div>
                                            {formData.recurrence === "Weekly" && (
                                                <div className="form-group col-md-6">
                                                    <label>Repeat On</label>
                                                    <Select
                                                        isMulti
                                                        options={weekdays}
                                                        value={weekdays.filter(day => formData.recurrenceDays.includes(day.value))}
                                                        onChange={selected =>
                                                            setFormData(prev => ({
                                                                ...prev,
                                                                recurrenceDays: selected.map(opt => opt.value),
                                                            }))
                                                        }
                                                    />
                                                </div>
                                            )}
                                            <div className="form-group col-md-6">
                                                <label>Recurrence start Date</label>
                                                <input type="date" className="form-control" name="startTime" value={formData.startTime} onChange={handleChange} />
                                            </div>
                                            <div className="form-group col-md-6">
                                                <label>Recurrence End Date</label>
                                                <input type="date" className="form-control" name="recurrenceEndDate" value={formData.recurrenceEndDate} onChange={handleChange} />
                                            </div>
                                        </>
                                    )}
                                </div>

                                <button type="submit" className="btn btn-primary mt-4">
                                    {props.id ? "Update Schedule" : "Create Schedule"}
                                </button>
                            </form>
                        </div>
                    )}
                </div>
            </div>

        </div>
    );
}

export default CreateScheduleComponent;

